import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Image } from 'semantic-ui-react';

import ForgotPassword from './ForgotPassword';
import LoginForm from './LoginForm';
import ResetPassword from './ResetPassword';
import ConfirmNewUser from './ConfirmNewUser';
import ResendVerification from './ResendVerification';

import * as AppActions from '../../actions';

import Images from '../../assets/Images';
import './Login.css';

class Login extends Component {
  state = {
    showForm: 'login',
    currentURL: '',
    loginUrls: [
      '/auth/login',
      '/auth/forgot_password',
      '/auth/reset_password',
      '/auth/activate_account'
    ]
  };

  componentDidMount() {
    this.init();
  }

  init = () => {
    const currentURL = window.location.pathname;
    const isLogin = this.state.loginUrls.find((url) => url === currentURL);
    const showForm = isLogin ? '' : this.state.showForm;
    this.setState({ currentURL, showForm });
  };

  handleSwitchForm = (name) => {
    this.setState({ showForm: name, currentURL: '' });
  };

  render() {
    const { showForm } = this.state;
    const { user, userLogged } = this.props;

    return (
      <div className="login-container">
        {user.loggedIn ? <Redirect to="/" /> : null}

        <Image
          src={Images.alexiaLogo}
          className="login-logo"
          alt="logo"
          verticalAlign="middle"
        />
        <div>
          {showForm === 'login' || this.state.currentURL === '/auth/login' ? (
            <LoginForm
              userLogged={userLogged}
              handleSwitchForm={this.handleSwitchForm}
            />
          ) : null}
        </div>
        <Container>
          {showForm === 'confirmNewUser' ||
          this.state.currentURL === '/auth/activate_account' ? (
            <ConfirmNewUser handleSwitchForm={this.handleSwitchForm} />
          ) : null}
        </Container>
        <Container>
          {showForm === 'resendVerification' ? (
            <ResendVerification handleSwitchForm={this.handleSwitchForm} />
          ) : null}
        </Container>
        <Container>
          {showForm === 'forgotPassword' ||
          this.state.currentURL === '/auth/forgot_password' ? (
            <ForgotPassword handleSwitchForm={this.handleSwitchForm} />
          ) : null}
        </Container>
        <Container>
          {showForm === 'resetPassword' ||
          this.state.currentURL === '/auth/reset_password' ? (
            <ResetPassword handleSwitchForm={this.handleSwitchForm} />
          ) : null}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/screens/Auth/Login.js